import Meta from '../../components/meta/meta';
import HeaderAppyShop, {getComponentStaticProps, HeaderProps} from '../../components/header/headerAppyShop'
import FooterAppyShop from '../../components/footer/footerAppyShop'
import {config} from '../../config-merchant'
import {useTranslation} from "next-i18next";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {appyShopConfig} from "../../config";
import styles from '../../styles/client-FAC.custom.module.scss';
import ImageViewer from "react-simple-image-viewer";
import React, {useState} from "react";
import ModalVideo from 'react-modal-video';

export default function About(props: { headerProps: HeaderProps }) {

    const {i18n} = useTranslation('common');
    const [currentViewerImage, setCurrentViewerImage] = useState<string>("");
    const [currentVideoId, setCurrentVideoId] = useState<string>("");

    const openPicture = (url: string) => {
        setCurrentViewerImage(url);
    }

    return (
        <>
            <Meta
                title={"A propos"}
                description={config.shopSlogan[i18n.language]}
                image={config.merchantDomain + config.defaultMetaImage}
                metaRobots={true}
            />
            <HeaderAppyShop activepage={'about'} headerProps={props.headerProps}/>
            {
                currentViewerImage !== "" && (
                    <ImageViewer
                        src={[currentViewerImage]}
                        currentIndex={0}
                        onClose={() => setCurrentViewerImage("")}
                        backgroundStyle={{backgroundColor: "rgba(0,0,0,0.8)", zIndex: 5}}
                    />
                )
            }
            <main>

                <div className={`${styles['about']} ${styles['custom']}`}>

                    <div className={styles["cover"]}>
                        <img src="/assets/images/FAC/about-cover-1.jpg" alt="cover"/>
                    </div>

                    <div className={styles["about-text1"]}>
                        <img src="/assets/images/FAC/illustration-violette.png" alt="violette"/>
                        <h2>Notre histoire !</h2>
                        <p>Bienvenue au pays Des Fleurs à Croquer ! Nous sommes une exploitation familiale spécialisée
                            dans la production, la transformation et la vente de fleurs cristallisées.</p>
                        <p>Nous cultivons hors-sol sous serre la violette, la rose, la menthe et la verveine en
                            agriculture biologique raisonnée, utilisées en confiserie, en fleurs comestibles et en
                            parfumerie.</p>
                        <p>Notre véritable atout réside dans la transformation artisanale, ou cristallisation, des
                            fleurs fraîches immédiatement après leur récolte.</p>
                    </div>

                    <div className={styles["about-imgs"]}>
                        <div><img src="/assets/images/FAC/about-img-1.jpg" alt={"Illustration violette"}/></div>
                        <div><img src="/assets/images/FAC/about-img-2.jpg" alt={"Illustration violette"}/></div>
                        <div><img src="/assets/images/FAC/about-img-3.jpg" alt={"Illustration violette"}/></div>
                    </div>

                    <div className={styles["about-text1"]}>
                        <h2>Le pays de la violette</h2>
                        <p>Située à 14 km à peine du littoral, dans l’arrière-pays Grassois, à Tourrettes-sur-Loup,
                            capitale de la violette, notre entreprise vous propose ses spécialités sucrées à déguster en
                            friandises, à apprécier avec le champagne, pour décorer vos desserts et des idées gourmandes
                            et originales pour vos mariages, baptêmes, communions…</p>
                        <div className={styles["about-cols"]}>
                            <div>
                                <ul>
                                    <li>Fleurs cristallisées :</li>
                                    <li className={styles["li-sub"]}>violette, rose, verveine et menthe</li>
                                    <li>Confits de fleurs de violette</li>
                                    <li>Sirops de fleurs</li>
                                </ul>
                            </div>
                            <div>
                                <ul>
                                    <li>Fleurs et feuilles séchées</li>
                                    <li>Savons artisanaux</li>
                                    <li>Coffrets découverte</li>
                                    <li>Violettes fraîches</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className={styles["about-imgs"]}>
                        <div><img src="/assets/images/FAC/about-img-4.jpg" alt={"Illustration violette"}/></div>
                        <div><img src="/assets/images/FAC/about-img-5.jpg" alt={"Illustration violette"}/></div>
                        <div><img src="/assets/images/FAC/about-img-6.jpg" alt={"Illustration violette"}/></div>
                    </div>

                    <div className={styles["about-text2"]}>
                        <p>Vous trouverez notamment au sein de notre <a href={"/catalog"}>boutique en ligne</a> les
                            célèbres bonbons à la violette, incontournable friandise des années 80 appréciée de tous les
                            gourmands. <a href={"/contact"}>Contactez-nous</a> pour plus de renseignements !</p>
                        <a href={"/catalog"}>
                            <div className={styles["button"]}>Notre catalogue complet</div>
                        </a>
                    </div>

                    <div className={styles["about-text1"]}>
                        <h2>Ils parlent de nous !</h2>
                        <p>Dans les journaux, à la télévision...</p>
                    </div>

                    <div className={styles["about-imgs"]}>
                        <div onClick={() => openPicture("/assets/images/FAC/about-img-7_large.jpg")}>
                            <img
                                alt={"Article journal"}
                                src="/assets/images/FAC/about-img-7.jpg"
                            />
                        </div>
                        <div>
                            <a href={"https://www.jingoo.com/album/postershop/detail_album.php?id_album=3119473"}
                               target={"_blank"}>
                                <img
                                    alt={"Album photo violette Ellen Teurlings"}
                                    src="/assets/images/FAC/about-img-8.jpg"
                                />
                            </a>
                        </div>
                        <div onClick={() => openPicture("/assets/images/FAC/about-img-9_large.jpg")}>
                            <img
                                alt={"Article nice matin"}
                                src="/assets/images/FAC/about-img-9.jpg"
                            />
                        </div>
                    </div>
                    <div className={styles["about-imgs"]}>
                        <div onClick={() => setCurrentVideoId("Dv6G9uE8oHs")}>
                            <img
                                alt={"Journal 13h France 2"}
                                src="/assets/images/FAC/about-img-10.jpg"
                            />
                        </div>
                        <div onClick={() => setCurrentVideoId("qOqxJK2zAac")}>
                            <img
                                alt={"Tour de france à Tourrettes-sur-loup"}
                                src="/assets/images/FAC/about-img-11.jpg"
                            />
                        </div>
                        <div onClick={() => setCurrentVideoId("P1DTQK-6GJs")}>
                            <img
                                alt={"Journal régional 19/20 France 2"}
                                src="/assets/images/FAC/about-img-12.jpg"
                            />
                        </div>
                    </div>
                </div>
                {currentVideoId !== "" && <ModalVideo
                    channel='youtube'
                    autoplay
                    isOpen={true}
                    videoId={currentVideoId}
                    onClose={() => setCurrentVideoId("")}/>}
            </main>
            <FooterAppyShop/>
        </>
    )
}


export const getStaticProps = async ({locale}) => {
    return {
        props: {
            ...await serverSideTranslations(locale, ['common']),
            headerProps: await getComponentStaticProps(locale)
        },
        revalidate: appyShopConfig.revalidateData
    }
}
